import {useEffect, useState} from 'react';
import {ProductSearchWidget} from "./ProductSearchWidget";
import {getProduct} from "../../api/Api";

export const ProductDisplayWidget = ({productId, onApiFail, refresh, onSelect, props}) => {
    const [product, setProduct] = useState(undefined);
    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        if ((productId === null) || (productId === undefined)) {
            setIsActive(true);
            return;
        }

        getProduct(productId).then(result => {
            setProduct(result);
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }, [onApiFail, productId, refresh]);

    const onClick = () => {
        setIsActive(true);
    }

    const handleSelect = (item) => {
        setIsActive(false);
        if (onSelect) {
            onSelect(item);
        }
    }

    const activeContent = <ProductSearchWidget onApiFail={onApiFail} refresh={refresh} onSelect={handleSelect} />

    const displayContent = <div onClick={onClick} style={{margin: '5px', cursor: 'pointer'}}><b>
        {product ? product.name : ""} </b>
    </div>

    return isActive ? activeContent : displayContent;
}